import _inject from "@stylexjs/stylex/lib/stylex-inject";
import React from 'react';
import * as stylex from '@stylexjs/stylex';
import Caption from "noood/comp/text/Caption";
import Title from "noood/comp/text/Title";
import FlexVertical from "noood/comp/ui/containers/flex-boxes/FlexVertical";
import Spacer from "noood/comp/ui/spacer/Spacer";
export default function RecordNotFound(props) {
  return /*#__PURE__*/React.createElement(FlexVertical, null, /*#__PURE__*/React.createElement(Title, {
    center: true,
    bold: true,
    size: 30
  }, "Record not found."), /*#__PURE__*/React.createElement(Spacer, {
    mtop: 10
  }), /*#__PURE__*/React.createElement(Caption, {
    center: true
  }, "The record you are looking for has either moved, has been deleted, or a record you are restricted to access."));
}
RecordNotFound.propTypes = {
  // proptypes
};
_inject(".evwsyq91{font-size:20px}", 3000);